// Foundations
import { Injectable } from '@angular/core';

// Services
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private _analytics: AngularFireAnalytics) {}

  // #region -> Log Event - Screen <-
  // ----------

  logScreen(screenName: string) {
    // this._logTap('screen_name', screenName);
    /*
      Use the default `screen_view` to track screen visit.
     */
    this._analytics.logEvent('screen_view', {
      screen_name: screenName,
    });
  }

  // ----------
  // #endregion

  // ///////////////////////////

  // #region -> Log Events - Click or Tap <-
  // ----------

  /*
    For both "button" and "link"
   */
  logButtonTap(buttonName: string) {
    this._logTap('tap_or_click', buttonName, 'button');
  }

  logLinkTap(linkName: string) {
    this._logTap('tap_or_click', linkName, 'link');
  }

  // ----------
  // #endregion

  // ///////////////////////////

  // #region -> Private <-
  // ----------

  private _logTap(eventName: string, itemId: string, contentType: string) {
    this._analytics.logEvent(eventName, {
      item_id: itemId,
      content_type: contentType,
    });
  }

  // ----------
  // #endregion

  // ///////////////////////////
}
